export class GPBackground {

    constructor(b) {

        this.typeName = "GPBackground"
        this.id = parseInt(b['-id']);
        this.ord = parseInt(b['-ord']);
        this.active = b['-ac'];
        this.file = b['-file'];
        this.name = b['-nm'];
        this.package = b['package'];
        this.farLineHeight = b['-farLineHeight'];
        this.farLineWidth = b['-farLineWidth'];
        this.designHeight = b['-designHeight'];
        this.designWidth = b['-designWidth'];

        this.thumbSrc = this.staticGetPathForThumb();

    }

    staticGetPathForImage () {
        return GPSettings.backgroundsAddr(this, false) + 'drawings/' + this.file;
    }

    staticGetPathForThumb () {
        return GPSettings.backgroundsAddr(this, true) + 'thumbs/' + this.file;
    }
}

